import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../store/sagas";
import {apiExternalPostForm, apiGet, apiPost} from "./client";

export const useCreateImage = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (file, uploadToken) {
        const {id} = yield call(apiExternalPostForm, 'https://media.scored.co', `/api/upload?token=${uploadToken}`, {file});
        return id;
    }, []));
};

export const useSetCommunityDesign = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (header, logo, uploadToken) {
        const {id} = yield call(apiExternalPostForm, 'https://media.scored.co', `/api/upload?token=${uploadToken}`, {header, logo});
        return id;
    }, []));
};

export const useUploadToken = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (type) {
        const {token} = yield call(apiGet, `/api/v2/upload/token.json?uploadType=${type}`);
        return token;
    }, []));
};

export const useResourceToken = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (community, name) {
        const {token} = yield call(apiGet, `/api/v2/upload/token.json?uploadType=communityResource&community=${community}&displayName=${name}`);
        return token;
    }, []));
};

export const useCommunityDesignToken = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (community, header, logo) {
        const {token} = yield call(apiGet, `/api/v2/upload/token.json?uploadType=communityDesign&community=${community}&header=${header}&logo=${logo}`);
        return token;
    }, []));
};

export const useDeleteResource = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (community, name) {
        const {token} = yield call(apiPost, `/api/v2/community/delete_resource.json?community=${community}&name=${name}`);
        return token;
    }, []));
};

export const useCreateVideo = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (file) {
        const {id} = yield call(apiExternalPostForm, 'https://videy.co', `/api/upload?`, {file});
        return id;
    }, []));
};